import React, { FunctionComponent } from 'react';
import { Input, ErrorMessage } from 'react-design-components';
import FormComponentProps from '../FormComponentProps';

interface FormData {
  lastName?: string;
}

const LastNameInput: FunctionComponent<FormComponentProps<FormData>> = ({ t, register, errors, defaultValue }) => {
  return (
    <>
      <Input
        inputProps={register('lastName', {
          required: t('validation.last_name.required'),
        })}
        id="lastName"
        type="text"
        label={t('last_name')}
        InputLabelProps={{
          htmlFor: 'lastName',
        }}
        error={!!errors.lastName}
        defaultValue={defaultValue}
      />
      {!!errors.lastName && <ErrorMessage>{errors.lastName.message}</ErrorMessage>}
    </>
  );
};

export default LastNameInput;
